/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrlogo1Inputs */

const en_qrlogo1 = /** @type {(inputs: Qrlogo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center logo (optional)`)
};

const de_qrlogo1 = /** @type {(inputs: Qrlogo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo in der Mitte (optional)`)
};

/**
* | output |
* | --- |
* | "Center logo (optional)" |
*
* @param {Qrlogo1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrlogo1 = /** @type {((inputs?: Qrlogo1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrlogo1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrlogo1(inputs)
	return de_qrlogo1(inputs)
});
export { qrlogo1 as "qrLogo" }